// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2U-T5","visuallyhidden":"KhW-H","hide-text":"yrezS","center":"_1dxDQ","noprint":"_2_1Wi","text":"_14KCe"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-text/styles/Text_Factbox.scss
 ** module id = 958
 ** module chunks = 1
 **/